/**
 * @author Hiroki Moto
 */

import React, { memo, useMemo } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from '@components/@core/AnimatedButton';
import Thumbnail from '@components/@core/Thumbnail';
import { ProductCard } from '@components/CompanyCard';
import { hasHtml } from '~/services/util';

const All = ({ data, logo, onDetail, onUpdate }) => {
    const updatable = useMemo(() => {
        if (data.products) {
            let _update = true;
            data.products.forEach((product) => {
                if (product.data?.sponsored_level === 'gold' || product.data?.sponsored_level === 'silver') _update = false;
            });
            return _update;
        }
        return false;
    }, [data.products]);

    const defaultImg = updatable ? '/images/no-image.jpg' : '/images/profile/products/all.png';

    return (
        <>
            <div className="card premium-all">
                <Row>
                    <Col md={6}>
                        <Thumbnail className="product-all-img" source={data?.title_url} defaultImg={defaultImg} size="responsive" />
                    </Col>
                    <Col className="pr-5" md={6}>
                        <p className="dsl-b18 bold">{`About ${data.name}`}</p>
                        {hasHtml(data.data?.description || '') ? <div dangerouslySetInnerHTML={{ __html: data.data.description }} /> : <p className="dsl-b16">{data.data.description}</p>}
                    </Col>
                </Row>
                {updatable && (
                    <div className="d-h-end">
                        <Button name="Update page" type="link" onClick={onUpdate} />
                    </div>
                )}
            </div>
            <div className="card mt-3">
                <p className="dsl-b24 bold mb-0">All Products</p>
                <div className="d-flex flex-wrap">
                    {data.products.map((item, index) => (
                        <ProductCard key={index} data={item} logo={logo} onDetail={() => onDetail(item.slug)} />
                    ))}
                </div>
            </div>
        </>
    );
};

export default memo(All);
